import { cartStore as useCartStore } from "#sitis/stores/modules/cart-store";
import { storeToRefs } from "pinia";
import { useNuxtApp } from "#imports";
export default function useCart() {
  const { $api } = useNuxtApp();
  const cartStore = useCartStore();
  const {
    itemsCart,
    itemsCount,
    totalSum,
    getLoadingInState
  } = storeToRefs(cartStore);
  const getCart = async () => {
    await cartStore.getCartItems();
  };
  const addToCart = async (body) => await cartStore.addToCart(body);
  const changeQuantity = async (cartItem) => await cartStore.updateCarItem({
    quantity: cartItem.quantity,
    cartItemId: `${cartItem.cartItemId}`,
    data: cartItem?.data || void 0,
    modificationId: cartItem?.modificationId || void 0
  });
  const removeItem = async (cartItemId) => {
    await cartStore.removeCartItem(cartItemId);
  };
  const clearCart = async () => {
    await cartStore.removeCartAll();
  };
  const getCheckoutData = async () => await $api.cartApi.getCheckoutData();
  const getUserOrders = async (queryParams) => await $api.userApi.getOrders(queryParams);
  return {
    itemsCart,
    itemsCount,
    totalSum,
    getLoadingInState,
    getUserOrders,
    getCheckoutData,
    clearCart,
    getCart,
    addToCart,
    changeQuantity,
    removeItem
  };
}
